import { skin } from "./config/api";

let skinInitPromise = null;

export const initApp = () => {
  if (skinInitPromise) {
    return skinInitPromise;
  }

  skinInitPromise = new Promise((resolve, reject) => {
    const LOCATION_URL = window.location.href;
    const isMrPayCard = process.env.REACT_APP_IS_MRPAY_CARD === "true";
    const isStage = process.env.REACT_APP_IS_STAGE === "true";

    const BASE_URL = isMrPayCard
      ? process.env.REACT_APP_API_ENDPOINT_MRPAYCARD_PRODUCTION
      : window.location.hostname.includes("staging") ||
        window.location.hostname.includes("login.mrpay.it") ||
        isStage
        ? process.env.REACT_APP_API_ENDPOINT_STAGE
        : process.env.REACT_APP_API_ENDPOINT_PRODUCTION;

    const isLocalHost = ["localhost", "ngrok"].some((loc) =>
      LOCATION_URL.includes(loc)
    );

    const applySkin = (currentSkin) => {
      if (currentSkin.tabThemeEdit) {
        const tabTheme = document.querySelector("#tabTheme");
        const tabTheme2 = document.querySelector("#tabTheme2");

        if (tabTheme) {
          tabTheme.setAttribute("content", currentSkin.mainColor);
        }

        if (tabTheme2) {
          tabTheme2.setAttribute("content", currentSkin.mainColor);
        }
      }

      if (currentSkin.styleContent) {
        const styleElement = document.createElement("style");
        styleElement.textContent = currentSkin.styleContent;
        document.head.appendChild(styleElement);
      }
    };

    fetch(`${BASE_URL}configurations`)
      .then((response) => response.json())
      .then((data) => {
        const { skins } = data;
        const localHostSkinId = 2;
        let selectedSkin = null;

        for (const currentSkin of skins || []) {
          const backofficeDomain =
            currentSkin?.skin?.backoffice_domain || "";

          const cleanedDomain = backofficeDomain.replace(/\/$/, "");

          const regex = new RegExp(cleanedDomain, "g");

          if (
            (cleanedDomain && LOCATION_URL.match(regex)) ||
            (isLocalHost && currentSkin.id === localHostSkinId)
          ) {
            selectedSkin = currentSkin;
            break;
          }
        }

        if (selectedSkin) {
          const skinId = String(selectedSkin.id);

          skin.skin_id = skinId;

          localStorage.setItem("skin_id", skinId);

          localStorage.setItem(
            "skin_name",
            selectedSkin?.skin?.name || ""
          );

          applySkin(selectedSkin);
        }

        const hostParts = window.location.host.split(".");

        document.title = hostParts[1]
          ? hostParts[1].toUpperCase() + " - Tutto con un click!"
          : window.location.host + " - Tutto con un click!";

        const rootEl = document.getElementById("root");

        if (rootEl) {
          rootEl.style.display = "block";
        }

        resolve(skin);
      })
      .catch((error) => {
        console.error("Error fetching configurations:", error);
        reject(error);
      });
  });

  return skinInitPromise;
};